import { JobPhaseReceivableInterface } from '../interfaces/job-phase-receivable.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import {
  IsBoolean,
  IsDecimal,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
import { Exclude, Expose, Type } from 'class-transformer';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { UserDto } from '../../user/dto/user.dto';
import { UserInterface } from '../../user/interfaces/user.interface';

@Exclude()
export class JobPhaseReceivableDto
  extends CommonEntityDto
  implements JobPhaseReceivableInterface
{
  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  @Expose()
  jobPhaseId!: string;

  @ApiProperty()
  @IsBoolean()
  @Expose()
  supplyProIntegrated!: boolean;

  @ApiProperty()
  @IsBoolean()
  @Expose()
  billed!: boolean;

  @ApiPropertyOptional()
  @IsNumber()
  @IsOptional()
  @Expose()
  invoicePOAmount!: number | null;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @Expose()
  internalInvoiceNumber!: string | null;

  @ApiPropertyOptional({ format: 'uuid' })
  @IsUUID()
  @IsOptional()
  @Expose()
  updatedByUserId!: string | null;

  @ApiPropertyOptional({ type: () => UserDto })
  @IsOptional()
  @Type(() => UserDto)
  @Expose()
  updatedByUser?: UserInterface;
}
